import airo from '../../assets/img/airo.png';
import elifTech from '../../assets/img/elifTech.png';
import filmoteka from '../../assets/img/filmoteka.png';
import ice from '../../assets/img/ice.png';
import jaguar from '../../assets/img/jaguar.png';
import lgran from '../../assets/img/lgran.png';
import palmira from '../../assets/img/palmira.png';
import petsPaw from '../../assets/img/petsPaw.png';
import rgb from '../../assets/img/rgb.png';
import soYammy from '../../assets/img/soYammy.png';
import threeFiberConcept from '../../assets/img/threeFiberConcept.png';

export const projectsList = [
   {
      livePageLink: 'https://iuliia-sokol.github.io/Ice-Project/',
      gitHubLink: 'https://github.com/iuliia-sokol/Ice-Project',
      title: 'Ice',
      description: `A website showcasing a project created using various technologies. Users can explore the interactive interface and learn about the features and functionality of this project, such as design, functions, and other visual elements. Responsive and adaptive layout. Team project. Role: developer, section products. Modal windows.`,
      utils: 'HTML, SASS, Parcel',
      img: ice,
   },
   {
      livePageLink: 'https://sl7one.github.io/projectFilm/',
      gitHubLink: 'https://github.com/sl7one/projectFilm',
      title: 'Filmoteka',
      description: `A website showcasing a collection of films from various genres, including action, drama, comedy, and more. Users can browse through the films and access detailed information about each movie, such as its synopsis, cast and crew, and release date. Team project. Role: team leader`,
      utils: 'HTML, SASS, JS, Notiflix, LightBox, Tui Pagination, Axios, REST API, AJAX, Parcel',
      img: filmoteka,
   },
   {
      livePageLink: 'https://loki99911.github.io/Node.JS_Project_Front/',
      gitHubLink: 'https://github.com/Loki99911/Node.JS_Project_Front',
      title: 'SoYuammy',
      description: `A frontend part of a project developed using Node.js, featuring an interactive interface for user interaction with various project components. It may include registration, authentication, database interaction, data display/input, and other project-specific functionalities. The website is designed with modern trends in web development, responsive design, and additional features such as animations and visual effects. Team project. Role: developer. Workflow: AddRecipe page, Motivated modals. Front-end - build on GitHub, Back-end - build on render.com`,
      utils: 'MERN stack, Axios, Styled-Components, Mui, Swiper, Select, Toastify',
      img: soYammy,
   },
   {
      livePageLink: 'https://sl7one.github.io/lgran-resto/',
      gitHubLink: 'https://github.com/sl7one/lgran-resto',
      title: 'LGran-resto',
      description: `Own pet-project. This landing page is about getting familiar with the GSAP library.`,
      utils: 'React, GSAP, Styled-Components, React-Select',
      img: lgran,
   },
   {
      livePageLink: 'https://sl7one.github.io/elifTech-test/',
      gitHubLink: 'https://github.com/sl7one/elifTech-test',
      title: 'ElifTech-delivery',
      description: `Own pet-project. This is a prototype of a food delivery SPA (Single Page Application). Users can order food from a restaurant, add items to the cart, and place an order. Additionally, there is functionality available to save order history.`,
      utils: 'MERN stack, GSAP, Styled-Components, MobX, Router-Dom',
      img: elifTech,
   },
   {
      livePageLink: 'https://sl7one.github.io/rgb-test/',
      gitHubLink: 'https://github.com/sl7one/rgb-test',
      title: 'RGB',
      description: `Front-end for RGB-company.`,
      utils: 'React, React-Router-Dom, Styled-Components, Toastify, React-Phone-Number, Email.js',
      img: rgb,
   },
   {
      livePageLink: 'https://sl7one.github.io/airo-medical-test/',
      gitHubLink: 'https://github.com/sl7one/airo-medical-test',
      title: 'Airo-medical',
      description: `Own pet-project. Every one loves bear :-).`,
      utils: 'React, React-Router-Dom, React-Cool-Virtual, React-Tabs, Tooltip, TypeScript, Zustand',
      img: airo,
   },
   {
      livePageLink: 'https://jaguarautotrans.com.ua/',
      gitHubLink: null,
      title: 'Jaguar-trans',
      description: `Markup for commercial project. Mobile-first adaptive layout`,
      utils: 'HTML, SASS, JS, JQuery, Slick',
      img: jaguar,
   },
   {
      livePageLink: 'https://palmira.od.ua/',
      gitHubLink: null,
      title: 'Palmira-club',
      description: `Markup for commercial project. Mobile-first adaptive layout`,
      utils: 'HTML, SASS, JS, JQuery, Slider',
      img: palmira,
   },
   // {
   //    livePageLink: 'https://sl7one.github.io/fake-store/',
   //    gitHubLink: 'https://github.com/sl7one/fake-store',
   //    title: 'Fake Store',
   //    description: `Pet-project. Used fakestore API for backend. Accent on pure CSS and CSS transitions.`,
   //    utils: 'React, Zustand, Axios, Swiper, Notiflix, TypeScript',
   //    img: petsPaw,
   // },
   {
      livePageLink: 'https://sl7one.github.io/Pets-Paw-react/',
      gitHubLink: 'https://github.com/sl7one/Pets-Paw-react',
      title: 'PetsPaw',
      description: `Pet-project. Used api.thecatapi.com for backend. Friendly pure CSS transitions. Adaptive layout`,
      utils: 'React,  Axios, Swiper, Toastify, React-Dropzone, React-Select, React-Router-Dom',
      img: petsPaw,
   },
   {
      livePageLink: 'https://sl7one.github.io/react-three-concept/',
      gitHubLink: 'https://github.com/sl7one/react-three-concept',
      title: 'React Three Concept',
      description: `Pet-project. Familiarity with React Three Fiber`,
      utils: 'Vite, React,  Gsap, React Three Fiber',
      img: threeFiberConcept,
   },
].reverse();
